<template>
  <div class="persionHome"
       style="background-color:#F5F7FA">
    <div class="div-color">
      <div class="active">
        <el-steps :active="active"
                  align-center>
          <el-step title="资料收集"></el-step>
          <el-step title="测算分析"></el-step>
          <el-step title="产品方案"></el-step>
          <el-step title="规划结论"></el-step>
        </el-steps>
      </div>
      <div class="btn">
        <el-button @click="previousStep"
                   v-show="active !== 0">上一步</el-button>
        <!-- <el-button type="primary"
                   @click="nextStep">下一步</el-button> -->
        <el-button type="primary"
                   @click="nextStep"
                   :disabled="disabledFlag"
                   v-if="active === 0">下一步</el-button>
        <el-button type="primary"
                   @click="nextStep"
                   :disabled="disabledFlag || getChildStepStatys"
                   v-if="active < 3 && active > 0">下一步</el-button>
        <el-button type="primary"
                   @click="complete"
                   v-if="active === 3">完成规划</el-button>
      </div>
    </div>
    <dataCollection v-if="active === 0"
                    :dialogStatus="dataCollectionDialog"
                    @custObj='custObjFn'
                    @toNextStepDisabled="getToNextStepDisabled"
                    ref="dataCollection"></dataCollection>
    <Analysis v-if="active === 1"
              @toNextStepDisabled="getToNextStepDisabled"></Analysis>
    <productPlan v-if="active === 2"
                 v-on:set-disabled-flag="disabledFlag = $event"
                 v-on:regular-prd-list="regularPrdList = $event"
                 ref="productPlan"></productPlan>
    <conclusion v-if="active === 3"></conclusion>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import dataCollection from './dataCollection.vue'; // 资料收集
import Analysis from './analysis.vue'; // 测算分析
import productPlan from './productPlan.vue'; // 产品方案
import conclusion from './conclusion.vue'; // 规划结论
// 规划结论
export default {
  name: 'persionHome',
  components: {
    dataCollection,
    Analysis,
    productPlan,
    conclusion,
  },
  data() {
    return {
      successCode: 'E00000',
      active: 0, // 进度
      // 默认都可以点下一步
      disabledFlag: false,
      // 常选产品列表
      regularPrdList: [],
      // 第一步教育储蓄金
      EducationReserve: {},
      dataCollectionDialog: '0',
      cust: '',
      planType: '',
      dataCollection: {}, // 资料收集页面的数据
    };
  },
  computed: {
    ...mapGetters(['getChildStepStatys']),
  },
  watch: {
    disabledFlag: {
      immediate: true,
      handler(val) {
        console.log('下一步', this.disabledFlag);
        console.log('监听是否下一步', val);
        console.log('监听是否下一步', this.getChildStepStatys);
      },
    },
  },
  created() {
    sessionStorage.setItem('custInfo', JSON.stringify(this.$route.query.row));
    sessionStorage.setItem('curCis', JSON.stringify(this.$route.query.row.cis));
    sessionStorage.setItem('flagFrom', JSON.stringify(0));
    this.cust = JSON.parse(sessionStorage.getItem('custInfo'));
    console.log('created----------------', this.getChildStepStatys);
  },
  methods: {
    previousStep() {
      if (this.active === 1) {
        sessionStorage.setItem('flagFrom', 1);
      }
      // 第一步页面，从列表进来传0，上一步进来传1
      this.dataCollectionDialog = '1';
      // 点击上一步，将下一步释放。
      if (this.active === 2) {
        this.disabledFlag = false;
      }
      if (this.active > 0) {
        this.active = this.active - 1;
      }
    },
    // 第四步保存快照
    complete() {
      let arr = [];
      for (let i = 0; i < JSON.parse(sessionStorage.getItem('histogram')).series.length; i++) {
        if (JSON.parse(sessionStorage.getItem('histogram')).series[i].name === '总资产') {
          arr = JSON.parse(sessionStorage.getItem('histogram')).series[i].data;
        }
      }
      const params = {
        data: {
          cis: this.cust.cis,
          planType: '2',
          createUserid: 1,
          measureReserveDTO: JSON.parse(sessionStorage.getItem('pensionBreachResult')),
          totalMoneyList: arr,
          token: JSON.parse(sessionStorage.getItem('userToken')),
          userId: JSON.parse(sessionStorage.getItem('sessionData')).userId,
        },
      };
      this.$_post(this.$API.snapshot, params).then((res) => {
        this.$message.closeAll();
        if (res.errorCode === 'E00000') {
          this.$message.success('成功!');
          this.$router.push({
            path: '/Home',
            query: {
              userId: JSON.parse(sessionStorage.getItem('sessionData')).userId,
              userToken: JSON.parse(sessionStorage.getItem('userToken')),
              sessionData: sessionStorage.getItem('sessionData'),
            },
          });
        }
        console.log(res);
      });
    },
    // 下一步
    async nextStep() {
      // eslint-disable-next-line no-plusplus
      if (this.active === 0) {
        this.$nextTick(function () {
          console.log('基本信息---', this.$refs.dataCollection);
          // 客户及配偶基本信息数据
          const self = this.$refs.dataCollection.obj.oneself;
          const spouse = this.$refs.dataCollection.obj.spouseTwo;
          const obj = { self: {}, spouse: {}, reserve: {} };
          // 储备金
          obj.reserve = this.$refs.dataCollection.obj.threeReserve;
          obj.reserve.cis = self.cis;
          // 本人数据
          obj.self.cis = self.cis;
          obj.self.name = self.name;
          obj.self.age = self.age;
          obj.self.sex = self.sex;
          obj.self.tSelf = self.tSelf;
          obj.self.retirementAge = self.retirementAge;
          obj.self.endYear = self.endYear;
          obj.self.monthExpend = self.monthExpend;
          obj.self.pensionSource = self.pensionSource;

          if (self.pensionSource == '2' && self.age < self.retirementAge) {
            // 每月工资
            obj.self.monthSalary = self.monthSalary;
            // 工资涨幅
            obj.self.wageIncrease = self.wageIncrease;
            // 账号结余
            obj.self.pensionYearEndBalance = self.pensionYearEndBalance;
            obj.self.socialSecurityYear = self.socialSecurityYear;
          } else if (self.pensionSource == '3' && self.age < self.retirementAge) {
            // 养老金缴费档次
            obj.self.pensionPaymentScale = self.pensionPaymentScale;
            obj.self.socialSecurityYear = self.socialSecurityYear;
            // 账号结余
            obj.self.pensionYearEndBalance = self.pensionYearEndBalance;
          } else if (self.age >= self.retirementAge) {
            if (self.pensionSource == '3' || self.pensionSource == '2') {
              // 每月领取社保金
              obj.self.socialSecurityPension = self.socialSecurityPension;
            }
          }
          if (spouse.name == undefined) {
            obj.self.custRelation = '0';
          }
          // 配偶的数据
          if (spouse.name != undefined) {
            // if (!spouse.name === "") {
            obj.self.custRelation = self.custRelation;
            obj.spouse.name = spouse.name;
            obj.spouse.age = spouse.age;
            obj.spouse.sex = spouse.sex;
            obj.spouse.tSelf = spouse.tSelf;
            obj.spouse.custRelation = spouse.custRelation;
            obj.spouse.cis = spouse.cis;
            obj.spouse.retirementAge = spouse.retirementAge;
            obj.spouse.endYear = self.endYear;
            obj.spouse.monthExpend = spouse.monthExpend;
            obj.spouse.pensionSource = spouse.pensionSource;
            if (spouse.pensionSource == '2' && spouse.age < spouse.retirementAge) {
              // 每月工资
              obj.spouse.monthSalary = spouse.monthSalary;
              // 工资涨幅
              obj.spouse.wageIncrease = spouse.wageIncrease;
              obj.spouse.socialSecurityYear = spouse.socialSecurityYear;
              obj.spouse.pensionYearEndBalance = spouse.pensionYearEndBalance;
            } else if (spouse.pensionSource == '3' && spouse.age < spouse.retirementAge) {
              // 养老金缴费档次
              obj.spouse.pensionPaymentScale = spouse.pensionPaymentScale;
              obj.spouse.socialSecurityYear = spouse.socialSecurityYear;
              obj.spouse.pensionYearEndBalance = spouse.pensionYearEndBalance;
            } else if (spouse.age >= spouse.retirementAge) {
              // 每月领取社保金
              if (spouse.pensionSource == '3' || spouse.pensionSource == '2') {
                obj.spouse.socialSecurityPension = spouse.socialSecurityPension;
              }
            }
          }

          // 配偶值处理 家庭养老金来源
          const params = {
            data: {
              pensionReserveSaveDTO: obj.reserve,
              pensionInfoSaveDTO: obj.self,
              pensionSpouseInfoDTO: obj.spouse,
              uId: JSON.parse(sessionStorage.getItem('sessionData')).userId,
            },
          };
          console.log('参数1111', params);

          for (const i in params.data) {
            for (const j in params.data[i]) {
              console.log('*----', j);
              if (j === 'currentMoney' || j === 'monthMoney' || j === 'expectedRevenue' || j === 'monthExpend' || j === 'pensionYearEndBalance' || j === 'monthSalary' || j === 'wageIncrease' || j === 'socialSecurityPension') {
                if (params.data[i][j] != null) {
                  params.data[i][j] = this.deleteComma(params.data[i][j]);
                }
              }
            }
          }
          console.log('参数：', params);
          this.nextStepFn(params);
        });
      } else if (this.active === 2) {
        // 保存方案描述
        this.$refs.productPlan.saveSchemeDescription();
        // 获取是是否是养老规划 2代表养老规划
        this.$nextTick(function () {
          this.planType = this.$refs.productPlan.planType;
          console.log('planType', this.planType);
          // 保存常选产品
          this.saveRegularPrd(this.planType);
          if (this.active < 3) {
            // eslint-disable-next-line no-plusplus
            this.active++;
          }
        });
      } else {
        // eslint-disable-next-line no-plusplus
        this.active++;
      }
    },
    nextStepFn(params) {
      return this.$_post(this.$API.saveData, params).then((res) => {
        this.$message.closeAll();
        if (res.errorCode === 'E00000') {
          this.$message.success('成功!');
          if (this.active < 3) {
            // eslint-disable-next-line no-plusplus
            this.active++;
          }
        } else {
          this.$message.error(res.errorMsg);
        }
      });
    },
    // 接受第一步教育储备金的input值
    getToEducationReserve(data) {
      // this.EducationReserve = data;
      const obj = this.deepCopy(data);
      // eslint-disable-next-line no-restricted-syntax
      for (const i in obj) {
        if (i === 'currentMoney' || i === 'monthMoney' || i === 'expectedRevenue') {
          // eslint-disable-next-line no-param-reassign
          obj[i] = obj[i].toString().replace(/,/g, '');
        }
      }
      this.EducationReserve = obj;
      console.log('父页面', this.EducationReserve.monthMoney);
    },
    // 深拷贝赋值对象
    deepCopy(obj) {
      const result = Array.isArray(obj) ? [] : {};
      // eslint-disable-next-line no-restricted-syntax
      for (const key in obj) {
        // eslint-disable-next-line no-prototype-builtins
        if (obj.hasOwnProperty(key)) {
          if (typeof obj[key] === 'object' && obj[key] !== null) {
            result[key] = this.deepCopy(obj[key]); // 递归复制
          } else {
            result[key] = obj[key];
          }
        }
      }
      return result;
    },
    getToNextStepDisabled(data, arr, type) {
      // 判断是否可以点击下一步  type是第几步传过来的
      // this.disabledFlag = data;
      // if (!arr && this.disabledFlag) {
      //   this.disabledFlag = true;
      // }
      if (type === 1) {
        if (data) {
          if (!arr) {
            this.disabledFlag = true;
          } else {
            this.disabledFlag = true;
          }
        } else if (data === false) {
          if (arr.length === 0) {
            this.disabledFlag = true;
          } else {
            this.disabledFlag = false;
          }
        } else if (arr.length === 0) {
          this.disabledFlag = true;
        }
      } else if (type === 2) {
        if (data) {
          this.disabledFlag = true;
        } else {
          this.disabledFlag = false;
        }
      }
      // console.log('*******2222222222222*', arr);
      // console.log(!arr);
      // console.log('是否可以下一步', data);
      // console.log('是否可以下一步-arr', arr, this.getChildStepStatys);
      console.log('是否可以下一步-disabledFlag', this.disabledFlag);
    },
    custObjFn(data) {
      console.log(data, 'zz----');
      for (const i in data) {
        for (const j in data[i]) {
          if (data[i][j] == '' || data[i][j] == null || data[i][j] == undefined) {
            this.disabledFlag = true;
            return false;
          }
          this.disabledFlag = false;
        }
        console.log('--------------11+', this.disabledFlag);
      }
    },
    // step3 保存常选产品
    saveRegularPrd(planTypes) {
      const params = {
        data: {
          list: this.regularPrdList,
          planType: planTypes,
          uId: JSON.parse(sessionStorage.getItem('sessionData')).userId,
        },
      };
      let api = '';
      if (planTypes == 2) {
        api = this.$API.addRegularPrdOld;
      } else {
        api = this.$API.addRegularPrd;
      }
      this.$_post(api, params)
        .then((res) => {
          this.$message.closeAll();
          if (res.errorCode === this.successCode) {
            this.$message.success('成功');
          }
        })
        .catch((err) => {
          console.log(err);
          this.previousStep();
        });
    },
    // 去掉千分符
    deleteComma(x) {
      if (x.toString().indexOf(',') === -1) {
        return x;
      }
      return x.toString().replace(new RegExp(',', 'g'), '');
    },
  },
};
</script>

<style scoped>
.persionHome {
  padding: 20px 20px;
}
.persionHome > .div-color {
  margin: 14px 0px;
  background-color: rgb(255, 255, 255);
}
.active {
  padding: 14px 0px 11px 0px;
  width: 60%;
}
.btn {
  display: flex;
  justify-content: flex-end;
  position: relative;
  right: 23px;
  bottom: 62px;
  width: 200px;
  float: right;
}
</style>
